import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const fileUrl = (path) => `${API}/files/${path}`;

export const TOKEN_KEY = "sg_token";

// public client
const pub = axios.create({ baseURL: API });

// admin client with auth header
const adminClient = axios.create({ baseURL: API });
adminClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
// Auto-logout on expired/invalid session
adminClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.endsWith("/admin/login")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

// Resolve an image path: absolute URLs pass through; relative /api/files paths get the backend origin
export const resolveImg = (url) => {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
};

// ---- public ----
export const getSettings = () => pub.get("/settings").then((r) => r.data);
export const getPoojas = (params) => pub.get("/poojas", { params }).then((r) => r.data);
export const getPooja = (slug) => pub.get(`/poojas/${slug}`).then((r) => r.data);
export const getBlogs = () => pub.get("/blogs").then((r) => r.data);
export const getBlog = (slug) => pub.get(`/blogs/${slug}`).then((r) => r.data);
export const getFaqs = (category) => pub.get("/faqs", { params: category ? { category } : {} }).then((r) => r.data);
export const getTestimonials = () => pub.get("/testimonials").then((r) => r.data);
export const getGuidanceList = () => pub.get("/guidance").then((r) => r.data);
export const getGuidance = (slug) => pub.get(`/guidance/${slug}`).then((r) => r.data);
export const submitEnquiry = (data) => pub.post("/enquiries", data).then((r) => r.data);
export const trackVisit = () => pub.post("/track/visit").then((r) => r.data).catch(() => {});

// ---- auth ----
export const login = (email, password) => pub.post("/auth/login", { email, password }).then((r) => r.data);

// ---- admin ----
export const adminList = (col) => adminClient.get(`/admin/${col}`).then((r) => r.data);
export const adminCreate = (col, body) => adminClient.post(`/admin/${col}`, body).then((r) => r.data);
export const adminUpdate = (col, id, body) => adminClient.put(`/admin/${col}/${id}`, body).then((r) => r.data);
export const adminDelete = (col, id) => adminClient.delete(`/admin/${col}/${id}`).then((r) => r.data);
export const adminStats = () => adminClient.get("/admin/stats/overview").then((r) => r.data);
export const generateBlog = (topic) => adminClient.post("/admin/generate-blog", { topic }, { timeout: 120000 }).then((r) => r.data);
export const adminUpdateSettings = (body) => adminClient.put("/admin/settings", body).then((r) => r.data);
export const adminUpload = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return adminClient.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminMe = () => adminClient.get("/auth/me").then((r) => r.data);

export const formatPrice = (n) =>
  typeof n === "number" ? `₹${n.toLocaleString("en-IN")}` : n;

export const CATEGORIES = [
  { value: "all", label: "All Poojas" },
  { value: "health", label: "Health" },
  { value: "marriage", label: "Marriage" },
  { value: "career", label: "Career & Business" },
  { value: "dosha", label: "Dosha Remedies" },
  { value: "family", label: "Family Welfare" },
  { value: "temple", label: "Temple Rituals" },
];

export const categoryLabel = (v) =>
  (CATEGORIES.find((c) => c.value === v) || {}).label || v;
